import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { CPC_BAR_CHART_OPTIONS } from './constants';
import { customCategories } from '../../../../utility';

const CPCChart = () => {
    const staticDataCompany = [];
    const showBenchMark = [61,165,150];
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch);
    const { isPaidSearchLoading } = dtcData;
    const {
        paidSearchCostData,
        isCostApiLoading
    } = useSelector((state) => state.webMatrix);
    const updatedCategories = customCategories(staticDataCompany.includes(company.id) ? ['2025-01','2025-02','2025-03'] : paidSearchCostData.map(item=> item.month));
    const isLoading = ( isCostApiLoading || isPaidSearchLoading);
    const data = (staticDataCompany.includes(company.id) ? [9.07, 7.55, 8.29] : paidSearchCostData.map(item=> item.cost) );
    const barChartOptions = useMemo(() => ({
        ...CPC_BAR_CHART_OPTIONS,
        xaxis: {
            ...CPC_BAR_CHART_OPTIONS.xaxis,
            categories: updatedCategories
        },
        plotOptions: {
            ...CPC_BAR_CHART_OPTIONS.plotOptions,
            bar: {
                ...CPC_BAR_CHART_OPTIONS.plotOptions.bar,
                columnWidth: updatedCategories.length > 10 ? '40%' : '50px'
            }
        },
        annotations: (showBenchMark.includes(company.id) && updatedCategories.length) ? {
            yaxis: [
                {
                    y: 9.5,
                    borderColor: '#007FFF',
                    strokeDashArray: 5,
                    label: {
                        text: '9.5$',
                        position: 'right',
                        style: { color: '#007FFF',fontWeight: 600 }
                    }
                }
            ]
        }:{}
    }), [paidSearchCostData]);
    
    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    {'CPC ($)'}
                </Typography>
            </Box>
            <Box className="wh-100" id="engagement-deciles">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={[{ name: 'CPC', data: data }]}
                        height={'300px'}
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default CPCChart;
